import { connect } from 'react-redux';
import { getThreadState } from '../../selectors';
import { threadUpdated } from '../../actionCreators';
import { getCurrentUser } from '../../../publicSession/selectors';
const mapStateToProps = (state, { commentableItemId, commentableTypeId, parentId })=>{
    const { streamId, canPostComment } = getThreadState(state, commentableTypeId, commentableItemId, parentId);
    return {
        streamId,
        currentUser: getCurrentUser(state),
        canPostComment
    };
};
const mapDispatchToProps = {
    onThreadUpdated: threadUpdated
};
export default connect(mapStateToProps, mapDispatchToProps);

//# sourceMappingURL=ThreadPostbox.container.js.map